import React, { useState, useEffect } from 'react';
import { jsPDF } from "jspdf";
import { FaDollarSign } from 'react-icons/fa';

import './styles.css';

import paymentServices from '../../../../services/academy/paymentServices';
import compare from '../../../../functions/compare';
import formatterBR, { formatter } from '../../../../functions/formatCurrency';

import StudentPaymentsCardItem from './StudentPaymentsCardItem';
import PopupNewPayment from './PopupNewPayment';
import PopupRenewEnrollment from './PopupRenewEnrollment';
import ActivityIndicator from '../../../../components/ActivityIndicator';

import squareIconLogoImg from '../../../../assets/square-icon-logo.png';

export default function StudentClassCard(props) {
    const [popupRenewEnrollment, setPopupRenewEnrollment] = useState(false);
    const [popupNewPaymentVisible, setPopupNewPaymentVisible] = useState(false);
    const [enrollments, setEnrollments] = useState({});
    const [payments, setPayments] = useState([]);
    const [paymentsCount, setPaymentsCount] = useState([]);
    const [fetching, setFetching] = useState(true);

    let formatterCurrency = props.currency && props.currency !== "BRL" ? formatter(props.currency) : formatterBR;

    function savePaymentReceiptPDF(paymentData) {
        console.log(paymentData);
        console.log(props.studentInfos);

        const doc = new jsPDF();

        doc.setFillColor("#010D35");
        doc.rect(0, 0, doc.internal.pageSize.width, 25, 'F');
        doc.addImage(squareIconLogoImg, 'PNG', (doc.internal.pageSize.width - 30) / 2, 15, 30, 30);
        doc.rect(0, doc.internal.pageSize.height - 15, doc.internal.pageSize.width, 15, 'F');

        doc.setFont(undefined, 'bold').setFontSize(24).text(
            (doc.internal.pageSize.width - 24 * 1) / 2, 90,
            "COMPROVANTE DE PAGAMENTO",
            {
                align: 'center',
                charSpace: '1'
            }
        );
        doc.setFont(undefined, 'normal').setFontSize(15).text(
            20, 120,
            `    Pagamento no valor de ${formatterCurrency.format(paymentData.valor_final)} realizado em ${paymentData.data?.split('-').reverse().join('/')}, referente ${props.studentInfos.genero[0] === 'F' ? "à aluna" : "ao aluno"} ${props.studentInfos.nome} ${props.studentInfos.sobrenome}.`,
            {
                maxWidth: doc.internal.pageSize.width - 40,
                align: 'justify'
            }
        );

        doc.setFontSize(12).text(
            doc.internal.pageSize.width / 2, 260,
            `Identificador: ${paymentData.identificador}`,
            'center'
        );

        let dateNow = new Date();
        doc.setFontSize(10).text(
            doc.internal.pageSize.width / 2, 270,
            `Gerado em ${dateNow.toLocaleString()}`,
            'center'
        );

        doc.save(`${paymentData.identificador}.pdf`);
    }

    async function readEnrollments() {
        const response = await paymentServices.getEnrollments(props.studentId);
        setFetching(false);
        if (response.status === 200) {
            setEnrollments(response.data);
            setPayments(response.data.matriculas.slice().sort((a, b) => compare(a.data_inicio, b.data_inicio, true)).map((item) => ({
                data_inicio: item.data_inicio,
                parcelas_totais: item.parcelas_totais,
                bolsa: item.bolsa,
                pagamentos: item.pagamentos.slice().reverse(),
                valor_final: item.valor_final
            })).filter((item) => item.pagamentos.length));
            console.log(response.data.matriculas.slice().sort((a, b) => compare(a.data_inicio, b.data_inicio, true)).map((item) => ({
                data_inicio: item.data_inicio,
                parcelas_totais: item.parcelas_totais,
                bolsa: item.bolsa,
                pagamentos: item.pagamentos.slice().reverse(),
                valor_final: item.valor_final
            })).filter((item) => item.pagamentos.length));
        } else
            alert("Erro ao ler matriculas e pagamentos, tente novamente!");
    }

    useEffect(() => {
        if (props.studentId)
            readEnrollments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.studentId]);

    useEffect(() => {
        setPaymentsCount(payments.reduce((aux, item) => aux + item.pagamentos.length, 0));
    }, [payments]);

    return (
        <div className='student-page-card' id='card-payments'>
            <div className='student-card-payments-header'>
                <div>
                    <h4><b><FaDollarSign />Pagamentos</b></h4>
                    <p>
                        {
                            enrollments.proximo_pagamento ?
                                <>
                                    <b>Vencimento:</b> {enrollments.proximo_pagamento.split('-').reverse().join('/')}
                                </>
                                : []
                        }
                    </p>
                </div>
                {
                    enrollments.matriculas && enrollments.matriculas.length ?
                        <span className={!enrollments.inadimplente ? '' : 'not-paid'}>{!enrollments.inadimplente ? 'Pago' : "Não pago"}</span>
                        : []
                }
            </div>

            {
                !fetching ?
                    <>
                        {
                            props.studentProfileMode ?
                                [] :
                                <>
                                    {
                                        enrollments.proximo_pagamento ?
                                            [] :
                                            <>
                                                <button
                                                    className='registration'
                                                    onClick={() => setPopupRenewEnrollment(true)}
                                                >Registrar matrícula</button>
                                                <PopupRenewEnrollment
                                                    visibility={popupRenewEnrollment}
                                                    setVisibility={setPopupRenewEnrollment}
                                                    studentId={props.studentId}
                                                    onCreate={() => {
                                                        readEnrollments();
                                                        props.setHaveNewDocument(true);
                                                    }}
                                                />
                                            </>
                                    }

                                    {
                                        enrollments.matriculas && enrollments.matriculas.length && enrollments.proximo_pagamento ?
                                            <>
                                                <button
                                                    className='new-payment'
                                                    onClick={() => setPopupNewPaymentVisible(true)}
                                                >Registrar pagamento</button>
                                                <PopupNewPayment
                                                    visibility={popupNewPaymentVisible}
                                                    setVisibility={setPopupNewPaymentVisible}
                                                    enrollments={enrollments.matriculas ? enrollments.matriculas
                                                        .filter((item) => item.parcelas_pagas < item.parcelas_totais)
                                                        .map((item) => ({ nome: `Contrato ${item.data_inicio.split('-').reverse().join('/')}${item.bolsa === "Sim" ? " [BOLSA]" : ""}`, id: item.id }))
                                                        : []
                                                    }
                                                    studentId={props.studentId}
                                                    onCreate={readEnrollments}
                                                />
                                            </>
                                            : []
                                    }

                                </>
                        }

                        <div className='student-card-payments-list-infos'>
                            <p><b>Histórico</b></p>
                            <p>{paymentsCount} registros</p>
                        </div>
                        {
                            payments.length ?
                                <>
                                    <ul className='student-card-payments-list'>
                                        {
                                            payments.flatMap((group) =>
                                                group.pagamentos.map((item, index) => {
                                                    const date = item.data.split('-').reverse();
                                                    return <StudentPaymentsCardItem
                                                        key={item.id}
                                                        date={`${date[0]}/${date[1]}/${date[2]}`}
                                                        scholarship={group.bolsa}
                                                        dateRef={group.data_inicio.split('-').reverse().join('/')}
                                                        payDateRef={item.data_referente.split('-').reverse().join('/')}
                                                        parcel={`${group.pagamentos.length - index}/${group.parcelas_totais}`}
                                                        savePaymentReceiptPDF={() => savePaymentReceiptPDF({ ...item, valor_final: group.valor_final })}
                                                    />
                                                })
                                            )
                                        }
                                    </ul>
                                    {/* {
                                        paymentsCount > 3 ?
                                            <button className='show-all'>Exibir tudo</button>
                                            : []
                                    } */}
                                </>
                                : []
                        }
                    </>
                    : <ActivityIndicator />
            }

        </div >
    )
}